"use client";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/navigation";

const NAV_ITEMS = [
  { label: "Assets challenges", id: "assets-challenges" },
  { label: "AI Agents", id: "ai-agents" },
  { label: "Contact us", id: "contact" },
];

export function Header() {
  const router = useRouter();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleOpenApp = () => {
    router.push("/login");
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black border-b border-dark-slate">
      <div className=" px-4 sm:px-7 lg:px-14 xl:px-28 py-5">
        <div className="flex justify-between items-center ">
          <Link href="/" className="flex items-center">
            <div className="relative w-28 h-7">
              <Image
                src="/assets/icons/assetilo-complete-desktop.svg"
                alt="Assetilo logo"
                fill
                className="object-contain hidden sm:block"
                priority
              />

              <Image
                src="/assets/icons/assetilo-complete-mobile.svg"
                alt="Assetilo logo"
                fill
                className="object-contain block sm:hidden"
                priority
              />
            </div>
          </Link>

          {/* Navigation and Button */}
          <div className="flex items-center gap-6">
            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center gap-7">
              {NAV_ITEMS.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-gray-400 hover:text-white text-base font-normal transition-colors"
                >
                  {item.label}
                </button>
              ))}
            </nav>

            <button
              onClick={handleOpenApp}
              className="bg-platinum text-neutral-1000 px-4 sm:px-5 py-2 rounded-lg text-sm sm:text-base font-inter font-medium hover:bg-white transition-colors"
            >
              Open App
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
